import {
  ContractorsListingGetters,
  ContractorsListingActions,
  ContractorsListingMutations
} from '@/app/features/contractors/features/contractors-listing/contractors-listing.keys';
import { contractorsListingService as contractorsService } from '@/app/features/contractors/features/contractors-listing/contractors-listing.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import i18n from '@/i18n';

export const getInitialState = () => {
  return {
    contractorsLoading: true,
    contractors: [],
    searchParam: '',
    contractorsRecordCount: 0,
    contractorsSortOrder: {
      sortBy: 'payrollnums',
      sortDirection: 'asc'
    },
    contractorsPaginationParameters: {
      recordsPerPage: 10,
      offset: 0
    },
    contractorsActiveInactive: 'both'
  };
};

export const contractorsListingStore = {
  state: getInitialState(),
  getters: {
    [ContractorsListingGetters.ContractorsList]: state => state.contractors,
    [ContractorsListingGetters.SortBy]: state => state.contractorsSortOrder.sortBy,
    [ContractorsListingGetters.SortDirection]: state => state.contractorsSortOrder.sortDirection,
    [ContractorsListingGetters.ContractorsPerPage]: state =>
      state.contractorsPaginationParameters.recordsPerPage,
    [ContractorsListingGetters.ContractorsListingOffset]: state =>
      state.contractorsPaginationParameters.offset,
    [ContractorsListingGetters.ContractorsRecordCount]: state => state.contractorsRecordCount,
    [ContractorsListingGetters.ContractorsActiveInactive]: state => state.contractorsActiveInactive
  },
  mutations: {
    [ContractorsListingMutations.SetContractorsLoading](state, isLoading = true) {
      state.contractorsLoading = isLoading;
    },
    [ContractorsListingMutations.SetContractorsList](state, contractors) {
      state.contractors = contractors;
    },
    [ContractorsListingMutations.SetContractorsSortOrder](state, sortOrder) {
      state.contractorsSortOrder = sortOrder;
    },
    [ContractorsListingMutations.SetContractorsPaginationParameters](state, pagination) {
      state.contractorsPaginationParameters = pagination;
    },
    [ContractorsListingMutations.ResetContractorsPaginationOffset](state) {
      state.contractorsPaginationParameters.offset = 0;
    },
    [ContractorsListingMutations.SetContractorsRecordCount](state, recordCount) {
      state.contractorsRecordCount = recordCount;
    },
    [ContractorsListingMutations.SetContractorsActiveInactive](state, activeInactive) {
      state.contractorsActiveInactive = activeInactive;
    },
    [ContractorsListingMutations.SetContractorsSearchParam](state, searchParam) {
      state.searchParam = searchParam;
      state.contractorsPaginationParameters.offset = 0;
    }
  },
  actions: {
    [ContractorsListingActions.RetrieveContractors]({ state, commit, dispatch }) {
      commit(ContractorsListingMutations.SetContractorsLoading);

      return contractorsService
        .retrieveContractors(
          state.contractorsActiveInactive,
          state.contractorsSortOrder,
          state.contractorsPaginationParameters,
          state.searchParam
        )
        .then(contractors => {
          contractors.map(contractor => {
            contractor.contractorName = contractor.last_name + ', ' + contractor.first_name;
          });
          dispatch(ContractorsListingActions.RetrieveContractorsRecordCount);
          commit(ContractorsListingMutations.SetContractorsList, contractors);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('contractors.listing.errors.retrieveContractors')
          });
          commit(ContractorsListingMutations.SetContractorsLoading, false);
        });
    },
    [ContractorsListingActions.SetContractorsSortOrder]({ commit, dispatch }, sortOrder) {
      commit(ContractorsListingMutations.SetContractorsSortOrder, sortOrder);
      commit(ContractorsListingMutations.ResetContractorsPaginationOffset);
      dispatch(ContractorsListingActions.RetrieveContractors);
    },
    [ContractorsListingActions.SetContractorsPaginationParameters](
      { commit, dispatch },
      pagination
    ) {
      commit(ContractorsListingMutations.SetContractorsPaginationParameters, pagination);
      dispatch(ContractorsListingActions.RetrieveContractors);
    },
    [ContractorsListingActions.ExportContractorsAsExcel]: function({ state }) {
      return contractorsService.downloadContractorsXlsx(
        state.activeInactive,
        state.sortOrder,
        state.pagingParameters,
        state.searchParam
      );
    },
    [ContractorsListingActions.SetContractorsActiveInactive]({ commit, dispatch }, activeInactive) {
      commit(ContractorsListingMutations.SetContractorsActiveInactive, activeInactive);
      dispatch(ContractorsListingActions.RetrieveContractors);
    },
    [ContractorsListingActions.RetrieveContractorsRecordCount]: ({ state, commit, dispatch }) => {
      return contractorsService
        .retrieveRecordCount(
          state.contractorsActiveInactive,
          state.contractorsPaginationParameters,
          state.searchParam
        )
        .then(res => {
          commit(ContractorsListingMutations.SetContractorsRecordCount, res);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error
          });
        });
    },
    [ContractorsListingActions.UpdateContractorsList]({ commit, dispatch }, contractorsList) {
      commit(ContractorsListingMutations.SetContractorsSearchParam, contractorsList.searchParam);
      commit(ContractorsListingMutations.SetContractorsLoading);
      return dispatch(ContractorsListingActions.RetrieveContractorsRecordCount)
        .then(() => {
          let contractorList = contractorsList.data;
          contractorList.map(contractor => {
            contractor.contractorName = contractor.last_name + ', ' + contractor.first_name;
          });
          commit(ContractorsListingMutations.SetContractorsList, contractorList);
        })
        .then(() => commit(ContractorsListingMutations.SetContractorsLoading, false));
    }
  }
};
